import { UIHeading4, UIText2 } from '@cian/ui-kit';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './SuburbanCatalog.css';
import { ISuburbanCatalog } from '../../../../../types/suburbanCatalog';

type ISuburbanCatalogProps = ISuburbanCatalog;

export const SuburbanCatalog: React.FC<ISuburbanCatalogProps> = ({ title, description, icon, link, onClick }) => {
  return (
    <a href={link} onClick={onClick} className={styles['container']} target="_blank" rel="noreferrer">
      <div className={classNames(styles['icon'], styles[icon])} />
      <div className={styles['text']}>
        <div className={styles['title']}>
          <UIHeading4>{title}</UIHeading4>
        </div>
        <UIText2 color="text-secondary-default">{description}</UIText2>
      </div>
      <div className={styles['arrow']}>
        <IconActionChevronRight12 color="icon-main-default" />
      </div>
    </a>
  );
};
